import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
} from '@chakra-ui/react';

import { ModalDownloadButton } from './ModalDownloadButton';
import modalStyles from './themedModal.module.css';

export type PdfPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  previewUrl?: string;
  downloadUrl?: string;
};

export const PdfPreviewModal = ({
  isOpen,
  onClose,
  title,
  previewUrl,
  downloadUrl,
}: PdfPreviewModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent className={modalStyles.content} height="90vh">
        <ModalHeader className={modalStyles.header} fontSize="md" py={3} pl={4}>
          {title}
        </ModalHeader>
        <ModalCloseButton />
        {downloadUrl && <ModalDownloadButton downloadUrl={downloadUrl} />}
        <ModalBody p={0} overflow="hidden">
          {previewUrl ? (
            <object
              data={previewUrl}
              type="application/pdf"
              width="100%"
              height="100%"
            >
              <p>
                Your browser does not support PDFs.
                <a href={previewUrl}>Download the PDF</a> to view it.
              </p>
            </object>
          ) : (
            <Spinner />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
